import React from 'react';
import { Checkbox, Form, Select } from 'antd';
import ProductCollectionPicker from 'components/pickers/product_collection';

const ProductCollectionsBlock = ({ form }) => {
    const display = Form.useWatch('display', form);

    return (
        <>
            <Form.Item
                label="Collections"
                name="collection_ids"
                rules={[{ required: true, message: 'Vui lòng chọn ít nhất 1 collection' }]}
            >
                <ProductCollectionPicker mode="multiple" placeholder="Chọn collections" />
            </Form.Item>

            <Form.Item
                label="Kiểu"
                name="display"
                rules={[{ required: true, message: 'Vui lòng chọn kiểu hiển thị' }]}
            >
                <Select
                    options={[
                        { label: 'Danh sách', value: 'list' },
                        { label: 'Slide', value: 'carousel' },
                        { label: 'Slide nhỏ', value: 'carousel_small' },
                    ]}
                    style={{ width: '100%' }}
                />
            </Form.Item>

            <Form.Item
                label="Tự động chạy"
                name={['slide_config', 'autoplay']}
                valuePropName="checked"
                hidden={!['carousel', 'carousel_small'].includes(display)}
                layout='horizontal'
            >
                <Checkbox />
            </Form.Item>

            <Form.Item
                label="Hiển thị hình tròn"
                name={['common_config', 'round_image']}
                valuePropName="checked"
                layout='horizontal'
            >
                <Checkbox />
            </Form.Item>

            <Form.Item
                label="Hiện tên collection"
                name={['common_config', 'show_name']}
                valuePropName="checked"
                layout='horizontal'
            >
                <Checkbox />
            </Form.Item>
        </>
    );
};

export default ProductCollectionsBlock;
